module.exports = __webpack_public_path__ + "static/media/RealEstate.198dc90d.png";